export class HttpError extends Error {
    readonly status: number;

    constructor(status = 500, message = 'Unknown error') {
        super(message);
        this.status = status;
    }
}

export class UnauthorizedError extends HttpError {
    constructor(message = 'User is not logged in') {
        super(401, message);
    }
}

export class BadRequestError extends HttpError {
    constructor(message = 'Bad Request') {
        super(400, message);
    }
}

export class UnprocessableEntityError extends HttpError {
    readonly errors: any[];

    constructor(message = 'Unprocessable Entity', errors: any[]) {
        super(422, message);
        this.errors = errors;
    }
}
